module.exports = __webpack_public_path__ + "img/bg_wedo.f6103f7d.jpg";